import React from "react";
import { Container } from "react-bootstrap";
import "./Deals.css";
const Deals = () => {
  return (
    <div className="section-container deal-container">
      <Container>
        <div className="row align-items-center">
          <div className="col-12 col-md-12 col-lg-4 col-xl-3 p-3">
            <div className="d-flex align-items-center justify-content-center">
              <div className="section-heading">
                <span>Offer for today</span>
                <br />
                <h2>Premium User offer</h2>
                <p>
                  Lorem ipsum dolor sit amet <br /> consectetur adipisicing.
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-12 col-lg-8 col-xl-9 p-3">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-8 col-xl-8 py-2">
                <div className="deal">
                  <div className="deal-sub1">
                    <img
                      src={require("../../../images/deals/deal-main.png")}
                      alt=""
                      className="h-100 w-100"
                    />
                    <div className="deal-text position-absolute top-0 start-0 p-3">
                      <div>
                        <h5 className="m-0 fw-light">Women's Skirt</h5>
                        <h4>$ 12.99</h4>
                      </div>
                    </div>
                  </div>
                  <div className="deal-sub12">
                    <div className="row h-100">
                      <div className="col-6 h-100">
                        <div className="deal-sub22 h-100">
                          <img
                            src={require("../../../images/deals/deal5.jpg")}
                            alt=""
                            className="h-100 w-100"
                          />
                          <div className="deal-text position-absolute top-0 start-0 p-3">
                            <div>
                              <h5 className="m-0 fw-light">Women's Skirt</h5>
                              <h4>$ 12.99</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-6 h-100">
                        <div className="deal-sub22 h-100">
                          <img
                            src={require("../../../images/deals/deal4.jpg")}
                            alt=""
                            className="h-100 w-100"
                          />
                          <div className="deal-text position-absolute top-0 start-0 p-3">
                            <div>
                              <h5 className="m-0 fw-light">Women's Skirt</h5>
                              <h4>$ 12.99</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-4 col-xl-4 py-2">
                <div className="deal">
                  <div className="deal-sub2">
                    <img
                      src={require("../../../images/deals/deal1.png")}
                      alt=""
                      className="h-100 w-100"
                    />
                    <div className="deal-text position-absolute top-0 start-0 p-3">
                      <div>
                        <h5 className="m-0 fw-light">Women's Skirt</h5>
                        <h4>$ 12.99</h4>
                      </div>
                    </div>
                  </div>
                  <div className="deal-sub2">
                    <img
                      src={require("../../../images/deals/deal2.png")}
                      alt=""
                      className="h-100 w-100"
                    />
                    <div className="deal-text position-absolute top-0 start-0 p-3">
                      <div>
                        <h5 className="m-0 fw-light">Women's Skirt</h5>
                        <h4>$ 12.99</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Deals;
